<p-panel header="{{'I18nValue.basicData' | hisUi}}">

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<his-plam>
		<p-autoComplete *ngIf="!childPublication?.publicationType.hiskeyId" #content  hisDdKey="fs.res.publication.Publication.publicationType"
			[ngModel]="publication.publicationType" (onSelect)="onPublicationTypeChange($event)" hisEagerDataSource="publicationTypeValue">
		</p-autoComplete>
        <p-autoComplete *ngIf="childPublication?.publicationType.hiskeyId" #content hisDdKey="fs.res.publication.Publication.publicationType"
        [ngModel]="publication.publicationType" (onSelect)="onPublicationTypeChange($event)" [hisEagerDataSource]="'api/v1/fs/res/publication/publicationTypes?child=' + childPublication.publicationType.id">
        </p-autoComplete>
	</his-plam>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
		
	<!-- decide which publicationTypes to show; we are using separate plams #273190 -->
	<ng-template *ngIf="isPublicationTypeBook;then isBook else isNoBook"></ng-template>
	<ng-template #isBook>
		<his-plam>
			<p-autoComplete name="docTypeBook" #content [hisDdKey]="getDdKey('documentType')"
				[(ngModel)]="publication.documentType" hisEagerDataSource="api/v1/fs/res/publication/documentTypes/book"
				(hisDataSourceDataAvailable)="clearAutocompleteForDocTypesIfNecessary()">
			</p-autoComplete>
		</his-plam>
	</ng-template>
	<ng-template #isNoBook>
		<his-plam>
	        <p-autoComplete name="docTypeArticle" #content [hisDdKey]="getDdKey('documentType')"
	            [(ngModel)]="publication.documentType" hisEagerDataSource="api/v1/fs/res/publication/documentTypes/article"
	            (hisDataSourceDataAvailable)="clearAutocompleteForDocTypesIfNecessary()">
	        </p-autoComplete>
		</his-plam>
	</ng-template>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
	
	<his-plam>
		<textarea hisDdKey="fs.res.publication.Publication.title" #content [(ngModel)]="publication.title" required class="textareaWidth100 textareaToForeground" rows="1" (input)="checkForDuplicates()"></textarea>
	</his-plam>
    <res-display-duplicates
        [duplicates]="duplicates" route="/pub/view" duplicatesMessageSuffix="byTitle" (linkClicked)="onBeforeNavigate()">
    </res-display-duplicates>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
	
	<his-plam>
		<textarea hisDdKey="fs.res.publication.Publication.subtitle" #content [(ngModel)]="publication.subtitle" class="textareaWidth100 textareaToForeground" rows="1"></textarea>
	</his-plam>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
		
	<his-multiselect-plam
	    ddKey="fs.res.publication.Publication.languages"
	    dataSource="language"
	    [selectedOptions]="publication.languages"
	    (selectedOptionsChange)="onSelectedLanguageChange($event)"
	    field="text">
	</his-multiselect-plam>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
	
	<his-plam>
		<p-inputNumber hisDdKey="fs.res.publication.Publication.releaseYear" #content [maxlength]="4" [(ngModel)]="publication.releaseYear" class="p-inputnumber-input"
                [useGrouping]="false">
        </p-inputNumber>
		
	</his-plam>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
	
	<his-plam *ngIf="hasStatusAuthority">	
		<!-- We are not using the GenericValueRestController because we need a filtered list #250459 -->
		<p-autoComplete #content hisDdKey="fs.res.publication.Publication.status"
			[(ngModel)]="publication.status" hisEagerDataSource="api/v1/fs/res/state/publication"
			(onClear)="onClear('status')">
		</p-autoComplete>
	</his-plam>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
	
	<his-plam *ngIf="!visibilitayDynamicFieldConfig">
		<p-autoComplete #content hisDdKey="fs.res.publication.Publication.visibilityValue"
			[(ngModel)]="publication.visibilityValue" hisEagerDataSource="visibilityValue"
			(onClear)="onClear('visibilityValue')">
		</p-autoComplete>
	</his-plam>
    <his-dynamicfield *ngIf="visibilitayDynamicFieldConfig" [form]="changeRequesForm" [valueGroup]="changeRequestValueGroup" [dynamicFieldConfig]="visibilitayDynamicFieldConfig"></his-dynamicfield>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>
</p-panel>
